export default __webpack_public_path__ + "static/media/ic_play_arrow_48px.16374525.svg";